export default {
  en: {
    DAILY_SUM_CAP_LABEL: 'Daily {capCriteria} cap',
    GLOBAL_SUM_CAP_LABEL: 'Global {capCriteria} cap',
    HOURLY_SUM_CAP_LABEL: 'Hourly {capCriteria} cap',
    MONTHLY_SUM_CAP_LABEL: 'Monthly {capCriteria} cap',
    DAILY_CAP_TT:
      'Calls will route to this {capCategory} until the daily call cap is reached.',
    GLOBAL_CAP_TT:
      'Calls will route to this {capCategory} until the global call cap is reached.',
    HOURLY_CAP_TT:
      'Calls will route to this {capCategory} until the hourly call cap is reached.',
    MONTHLY_CAP_TT:
      'Calls will route to this {capCategory} until the monthly call cap is reached.',
    NONE_TEXT: 'None',
    PUBLISHER_PAYOUT_GLOBAL_SUM_CAP_LABEL: 'Global Payout Cap',
    PUBLISHER_PAYOUT_GLOBAL_SUM_CAP_TT:
      'Payouts will be credited until the global payout cap is reached.',
    PUBLISHER_PAYOUT_GLOBAL_CAP_TT:
      'Payouts will be credited until the global call cap is reached.',
    PUBLISHER_PAYOUT_GLOBAL_CAP_LABEL: 'Global Cap',
    PUBLISHER_PAYOUT_MONTHLY_SUM_CAP_TT:
      'Payouts will be credited until the monthly payout cap is reached.',
    PUBLISHER_PAYOUT_MONTHLY_SUM_CAP_LABEL: 'Monthly Payout Cap',
    PUBLISHER_PAYOUT_MONTHLY_CAP_TT:
      'Payouts will be credited until the monthly call cap is reached.',
    PUBLISHER_PAYOUT_MONTHLY_CAP_LABEL: 'Monthly Cap',
    PUBLISHER_PAYOUT_DAILY_SUM_CAP_TT:
      'Payouts will be credited until the daily payout cap is reached.',
    PUBLISHER_PAYOUT_DAILY_SUM_CAP_LABEL: 'Daily Payout Cap',
    PUBLISHER_PAYOUT_DAILY_CAP_TT:
      'Payouts will be credited until the daily call cap is reached.',
    PUBLISHER_PAYOUT_DAILY_CAP_LABEL: 'Daily Cap',
    PUBLISHER_PAYOUT_HOURLY_SUM_CAP_TT:
      'Payouts will be credited until the hourly payout cap is reached.',
    PUBLISHER_PAYOUT_HOURLY_SUM_CAP_LABEL: 'Hourly Payout Cap',
    PUBLISHER_PAYOUT_HOURLY_CAP_TT:
      'Payouts will be credited until the hourly call cap is reached.',
    PUBLISHER_PAYOUT_HOURLY_CAP_LABEL: 'Hourly Cap',
    PUBLISHER_PAYOUT_CONCURRENCY_CAP_TT:
      'Payouts will be credited until the concurrency cap is reached. When a call is completed, payouts will continue to accrue.',
    PUBLISHER_PAYOUT_CONCURRENCY_CAP_LABEL: 'Concurrency Cap'
  }
};
